var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-9 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete element") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M11.923,75.611A8.894,8.894,0,0,0,20.77,84.5H56.157A8.894,8.894,0,0,0,65,75.611V22.278H11.923ZM22.8,43.967,29.042,37.7l9.422,9.422L47.841,37.7l6.237,6.267L44.7,53.389l9.377,9.422-6.237,6.267-9.377-9.422-9.377,9.422-6.237-6.267,9.377-9.422ZM53.945,8.944,49.522,4.5H27.4L22.982,8.944H7.5v8.889H69.427V8.944Z",
    transform: "translate(-7.5 -4.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinDelete);
export default __webpack_public_path__ + "static/media/binDelete.ed08898c41a6836596b72beae5dec612.svg";
export { ForwardRef as ReactComponent };